import React from 'react';
import styled from 'styled-components';

import SimpleResultContainer from '../../containers/retention/simple/RetentionResult';
import RetentionHeader from './RetentionHeader';
import RetentionSimplifiedComposeContainer from '../../containers/retention/simple/RetentionSimplifiedComposeContainer';
import NavigationBar from '../navigation/NavigationBar';
import SpinnerWithButton from '../common/SpinnerWithButton';

const RetentionContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 63px);
  justify-content: space-between;

  .retention__wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow-y: auto;
  }

  .retention__main {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 20px;
  }
`;

const Retention = ({
  executing,
  onExecute,
  extraActions,
  onRequestCancel,
  cancelButtonDisabled,
}) => (
  <>
    <NavigationBar onExecute={onExecute} executeDisabled={executing} extraActions={extraActions} />
    <RetentionContainer>
      <div className="st-retention-view retention__wrapper">
        <SpinnerWithButton
          onClick={onRequestCancel}
          disabled={cancelButtonDisabled}
          executing={executing}
        >
          <div className="retention__main">
            <RetentionHeader />
            <RetentionSimplifiedComposeContainer />
            <SimpleResultContainer />
          </div>
        </SpinnerWithButton>
      </div>
    </RetentionContainer>
  </>
);

export default Retention;
